import { Capacitor } from "@capacitor/core";

// FMS 서버 기본 주소
// - HTTPS 페이지에서 http FMS 를 직접 호출하면 Mixed Content 로 차단되므로,
//   운영 환경은 nginx 의 /fms/ 프록시를 경유한다.
const host = window.location.hostname;
const isDevHost =
    host === "localhost" || host.startsWith("192.168.") || host === "10.0.2.2";

let fmsBase = "";

if (Capacitor.isNativePlatform()) {
    // 모바일 앱은 상대경로를 쓸 수 없으므로 절대 주소 사용
    fmsBase = isDevHost
        ? "http://fms.asijang.co.kr:5376"
        : "https://retechapp.asijang.co.kr/fms";
} else {
    // 웹: 개발(http)은 직접 호출, 운영(https)은 같은 도메인의 /fms 프록시 사용
    fmsBase = isDevHost
        ? "http://fms.asijang.co.kr:5376"
        : window.location.origin + "/fms";
}

export const FMS_BASE = fmsBase;
